<template>
  <div class="row justify-content-center">
    <div class="wd-77">
      <h3 class="text-center" style="margin-bottom: 30px;">Aggiorna Consensi PRIVACY</h3>
      <b-form @submit.prevent="onFormSubmit">
        <b-row style="margin-bottom: 20px;">
          <b-col>
            <strong>REGOLAMENTO & PRIVACY</strong><span> - Ho letto, compreso e accettato il 
            </span>
            <b-link href="#" style="color: #111; font-weight: bold; text-decoration-line: underline;" @click="showModal('rules')">
            Regolamento
            </b-link>
            <span>  e la </span>
            <b-link href="#" style="color: #111; font-weight: bold; text-decoration-line: underline;" @click="showModal('privacy')">Privacy Policy</b-link>
            <span> del Servizio DogMotics.</span>
            <b-form-checkbox
              id="consent_mand_1"
              style="margin-top: 5px"
              v-model="userPrivacy.consent_mand_1"
              name="checkbox-1"
              value="true"
              unchecked-value="false"
              required
              switch
            > (obbligatorio)
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row style="margin-bottom: 20px;">
          <b-col>
            <strong>VIDEOSORVEGLIANZA</strong><span> - Ho letto, compreso e accettato i termini contenuti nella </span> 
            <b-link href="#" style="color: #111; font-weight: bold; text-decoration-line: underline;" @click="showModal('videoSurv')">Liberatoria Videosorveglianza</b-link>
            <span> utilizzata per la sicurezza h24 dei locali e dei clienti del Servizio di Lavaggio cani DogMotics.</span> 
            <b-form-checkbox
              id="consent_mand_2"
              style="margin-top: 5px"
              v-model="userPrivacy.consent_mand_2"
              name="checkbox-2"
              value="true"
              unchecked-value="false"
              required
              switch
            > (obbligatorio)
            </b-form-checkbox>
          </b-col>
          <b-col>
            <strong>COMUNICAZIONI</strong>
            <span> - Acconsento all'utilizzo dei miei dati di contatto per comunicazioni urgenti di servizio ed eventuali promozioni provenienti dal mio negozio DogMotics.</span>
            <b-form-checkbox
              id="consent_mand_3"
              style="margin-top: 5px"
              v-model="userPrivacy.consent_mand_3"
              name="checkbox-3"
              value="true"
              unchecked-value="false"
              required
              switch
            > (obbligatorio)
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row style="margin-bottom: 20px;">
          <b-col>
            <strong>MARKETING "PET"</strong>
            <span> - Acconsento all'utilizzo dei miei dati di contatto per comunicazioni commerciali e di marketing da parte di partner commerciali del "mondo del PET" selezionati da DogMotics.</span> 
            <b-form-group>
              <b-form-radio-group
                id="consenso opzionale 1"
                style="margin-top: 5px"
                v-model="userPrivacy.consent_opt_1"
                :options="consent1_options"
                name="radio-options-slots1"
                required
              >(facoltativo)
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col>
            <strong>MARKETING "ALTRO"</strong>
            <span> - Acconsento all'utilizzo dei miei dati di contatto per offerte e promozioni di partner commerciali di DogMotics.</span>
            <b-form-group>
              <b-form-radio-group
                id="consenso  opzionale 2"
                style="margin-top: 5px"
                v-model="userPrivacy.consent_opt_2"
                :options="consent2_options"
                name="radio-options-slots2"
                required
              >(facoltativo)
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="form-group text-center">
          <b-button type="submit" size="lg" class="mx-auto p-1" pills variant="primary" style="width: 200px">SALVA</b-button>
        </div>
      </b-form>
      <!-- MODAL panels -->
      <b-modal ref="privacyData" centered hide-footer title="My data">
        <div class="d-block text-center">
          <h3>I tuoi dati</h3>
        </div>
        <b-list-group style="margin-top: 20px;  margin-bottom: 20px;">
          <b-list-group-item class="d-flex justify-content-between align-items-left">
          </b-list-group-item>
        </b-list-group>
        <b-button class="mt-2 mx-auto" variant="outline-secondary" block @click="hideModal('privacyData')">
          CHIUDI
        </b-button>
      </b-modal>
      <b-modal ref="success" centered hide-footer title="Registro Privacy AGGIORNATO">
        <div class="d-block text-center">
          <h3>Registro consensi Privacy di {{ auth_user.displayName }} aggiornato.
          </h3>
        </div>
        <b-button class="mt-2 mx-auto" variant="outline-secondary" block @click="hideModal('success')">
          CHIUDI
        </b-button>
      </b-modal>
      <b-modal ref="error" centered hide-footer title="Registro Privacy MANCANTE">
        <div class="d-block text-center">
          <h3>Registro consensi Privacy di {{ auth_user.displayName }} da creare.
          </h3>
        </div>
        <b-button class="mt-2 mx-auto" variant="outline-secondary" block @click="hideModal('error')">
          CHIUDI
        </b-button>
      </b-modal>
      <b-modal size="lg" ref="rules" centered hide-footer title="Regolamento">
        <div style="position: relative; overflow: hidden; width: 100%;">
          <iframe style="position: relative; overflow: hidden; width: 100%; padding: 10px;" :src="rulesLink"></iframe>
        </div>
        <b-button class="mt-2 mx-auto" size="md" variant="outline-secondary" block @click="hideModal('rules')">
          CHIUDI
        </b-button>
      </b-modal>
      <b-modal size="lg" ref="privacy" centered hide-footer title="Privacy Policy">
        <div style="position: relative; overflow: hidden; width: 100%;">
          <iframe style="position: relative; overflow: hidden; width: 100%; padding: 10px;" :src="privacyLink"></iframe>
        </div>
        <b-button class="mt-2 mx-auto" size="md" variant="outline-secondary" block @click="hideModal('privacy')">
          CHIUDI
        </b-button>
      </b-modal>
      <b-modal size="lg" ref="videoSurv" centered hide-footer title="Videosorveglianza h24">
        <div style="position: relative; overflow: hidden; width: 100%;">
          <iframe style="position: relative; overflow: hidden; width: 100%; padding: 10px;" :src="videoSurvLink"></iframe>
        </div>
        <b-button class="mt-2 mx-auto" size="md" variant="outline-secondary" block @click="hideModal('videoSurv')">
          CHIUDI
        </b-button>
      </b-modal>
    </div>
  </div>
</template>

<script>
  import { db, timestamp } from '../../firebase/config.js';
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        userPrivacy: {
          consent_mand_1: null,
          consent_mand_2: null,
          consent_mand_3: null,
          consent_opt_1: null,
          consent_opt_2: null,
          formConsent: 'userPrivacy form dated 01.01.2024',
          createdOn: null,
          createdBy: null,
          createdIPAddress: null,
          modifiedOn: null,
          modifiedBy: null,
          modifiedIPAddress: null,
        },
        consent1_options: [
          { text: 'SI', value: true },
          { text: 'NO', value: false }
        ],
        consent2_options: [
          { text: 'SI', value: true },
          { text: 'NO', value: false }
        ],
        userIpAddress: null,
        error: {
          value: null,
          message: ''
        },
        success: {
          value: null,
          message: ''
        },
        rulesLink: "https://firebasestorage.googleapis.com/v0/b/dogmoticswebapp.appspot.com/o/DOCs%2Fregolamento.html?alt=media&token=0e3eaecd-127e-4790-a573-bd76d939ab94",
        privacyLink: "https://firebasestorage.googleapis.com/v0/b/dogmoticswebapp.appspot.com/o/DOCs%2Fprivacy_mi1.html?alt=media&token=0c22f788-823e-42f7-80ac-7d9098a67c0a",
        videoSurvLink: "https://firebasestorage.googleapis.com/v0/b/dogmoticswebapp.appspot.com/o/DOCs%2Fvideosorveglianza.html?alt=media&token=65381ee5-0974-45f6-bc43-eea41357e5dd"
      }
    },
    created() {
      console.log('userID: ', this.auth_user.uid)
      db.collection('users')
      .doc(this.auth_user.uid)
      .collection('privacy')
      .get()
      .then((querySnapshot) => {
        if(querySnapshot.empty) {
          this.showModal('error')
          //this.error.message = 'Per accedere al servizio occorre registrare i consensi privacy.'
        }
        else {
          const userPrivacyDoc = []
          querySnapshot.forEach((doc) => {
            userPrivacyDoc.push({
              data: doc.data()
            })
          })
          this.userPrivacy = userPrivacyDoc[0].data
        }
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      })
    },
    mounted() {
      fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(response => {
          this.userIpAddress = response.ip;
        });
    },
    methods: {  
      showModal(modalName) {
        this.$refs[modalName].show()
      },
      hideModal(modalName) {
        this.$refs[modalName].hide()
        /*if(modalName === 'success') {
          this.$router.push({name:'user_profile'})
        }*/
      },  
      onFormSubmit(event) {
        event.preventDefault();
        if(!this.userPrivacy.createdBy) {
          this.userPrivacy.createdOn = timestamp
          this.userPrivacy.createdBy = this.auth_user.uid
          this.userPrivacy.createdIPAddress = this.userIpAddress
        }
        else {
          this.userPrivacy.modifiedOn = timestamp
          this.userPrivacy.modifiedBy = this.auth_user.uid
          this.userPrivacy.modifiedIPAddress = this.userIpAddress
        }
        db.collection('users')
        .doc(this.auth_user.uid)
        .collection('privacy')
        .doc(this.auth_user.uid)
        .set(this.userPrivacy, {merge: true})
        .then(() => {
          console.log("Registro Consensi Privacy aggiornato!");
          this.showModal('success');
        })
        .catch((error) => {
          console.log(error.message, error)
          this.showModal('error');
        });
      },
    },
    computed: {
      ...mapGetters({
        // map `this.auth_user` to `this.$store.getters.user`
        auth_user: "user",
      }),
    },
  };
</script>

<style>
  .btn-primary {
    background: #bad300;
    border: #bad000;
  }
  .material-icons {
    font-size: 24px;
    margin-right: 10px;
    color: #ccc;
    cursor: pointer;
  }
  .material-icons:hover {
    color: #777;
  }
  .success {
    color: $success;
  }
</style>